import React, { useState, useRef, Suspense } from 'react';

import { Canvas, MeshProps, useFrame, useLoader } from '@react-three/fiber';

import { TextureLoader } from 'three/src/loaders/TextureLoader';

const Bubble: React.FC<MeshProps> = (props) => {
    // This reference will give us direct access to the mesh
    const speed = Math.floor( Math.random() * 3 ) / 10 + 0.3;
    const mesh = useRef<THREE.Mesh>(null!)
    //THREE.CircleGeometry( 5, 32 )
  
    // Set up state for the hovered and active state
    const [hovered, setHover] = useState(false)
    const [active, setActive] = useState(false)
    // Rotate mesh every frame, this is outside of React without overhead
    useFrame(() => {
      if ( mesh.current.position.y > 140 ) {
        //mesh.current.scale = Math.floor( Math.random() * 15 + 5)/10;
        mesh.current.position.y = -140;
        mesh.current.position.x = Math.floor( Math.random() * 80 ) - 40;
        mesh.current.position.z = - Math.floor( Math.random() * 150 );
        return mesh;
      } else {
        mesh.current.position.y += speed; //0.4;
        //mesh.current.position.x += Math.floor( Math.random() * 2 - 1 ) / 10;
        return mesh;
      }
      
    })
  
    return (
      <mesh
        {...props}
        ref={mesh}
        scale={Math.floor( Math.random() * 15 + 5)/10}
        //opacity={0.3}
        //onClick={(event) => ()setActive(!active)}
        //onPointerOver={(event) => setHover(true)}
        //onPointerOut={(event) => setHover(false)}
      >
        {/*<boxGeometry args={[1, 2, 3]} />*/}
        <sphereGeometry args={[1, 32, 32]} />
        <meshPhongMaterial color={'#F9D34C'} transparent={true} opacity={0.45} />
      </mesh>
    );
    //<meshStandardMaterial color={'#2F451E'} /*transparent={true} opacity={0.2}*/ />
}

const BitmapImage: React.FC<MeshProps> = (props) => {
    const mesh = useRef<THREE.Mesh>(null!)
    const texture_1 = useLoader(TextureLoader, '/img/kuumailmapallo.jpg');
    const texture_2 = useLoader(TextureLoader, '/img/leadtrigger-og.jpg');
    const texture_3 = useLoader(TextureLoader, '/img/lead-trigger-og.jpg');
    const texture_4 = useLoader(TextureLoader, '/img/leadtrigger.svg');
    //mesh.position.z = -150;
    useFrame(() => {
        
        if (mesh.current.position.z > -90) {
            mesh.current.position.z = mesh.current.position.z + mesh.current.position.z/100;
            //mesh.current.rotation.x += 0.2;
            mesh.current.rotation.y += 0.012;
            //mesh.current.position.x -= 0.25;
        } else {
            mesh.current.rotation.y += 0.006;
        }
        return mesh;
    })
    //position={[0,0,-25]}
    const opacity = 0.9;
    return <mesh 
        ref={mesh}
        {...props}
    >
        {/*<boxBufferGeometry attach="geometry" args={[50, 50, 50]} />*/}
        <sphereGeometry /*attach="geometry"*/ args={[30, 30, 30]} />
        <meshStandardMaterial map={texture_2} transparent={true} opacity={opacity} />
        {/*<meshStandardMaterial map={texture_1} attachArray="material" transparent={true} opacity={opacity} />
        <meshStandardMaterial map={texture_2} attachArray="material" transparent={true} opacity={opacity} />
        <meshStandardMaterial map={texture_3} attachArray="material" transparent={true} opacity={opacity} />
        <meshStandardMaterial map={texture_3} attachArray="material" transparent={true} opacity={opacity} />
        <meshStandardMaterial map={texture_3} attachArray="material" transparent={true} opacity={opacity} />
<meshStandardMaterial map={texture_4} attachArray="material" transparent={true} opacity={opacity} />*/}
    </mesh>;
    //<meshStandardMaterial map={texture_2} color={'#424242'} attach="material" transparent={true} opacity={1} />
}

const Bubbles = () => {
    
    const bubbles: any[] = [];
    //const texture1 = new THREE.TextureLoader().load( '/img/kuumailmapallo.jpg' );
    //const texturePass1 = new TexturePass( texture1 );
    //const texture1 = useLoader<THREE.TextureLoader>('/img/kuumailmapallo.jpg')
    //const texture1 = useLoader(THREE.TextureLoader, '/img/kuumailmapallo.jpg');
    //useLoader(texture1, '/img/kuumailmapallo.jpg');

    for (let xi = 1; xi < 300; xi++) {
        bubbles.push([
            Math.floor( Math.random() * 80 ) - 40, 
            - 140 + Math.floor( Math.random() * 280 ), 
            - Math.floor( Math.random() * 150 ) - 20
        ]);
    }

    return (
        <div className="w-screen h-screen">
            <Canvas>
                <ambientLight intensity={0.8} />
                {/*<ambientLight />
                <pointLight position={[10, 10, 10]} />
                <ambientLight intensity={0.2} />
                <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} />
                <pointLight position={[-10, -10, -10]} />*/}
                <spotLight position={[10, 10, 10]} angle={0.25} penumbra={1} intensity={0.8} />
                { bubbles.map((bubble: any, key: number) => (
                    <Bubble position={[...bubble]} key={key} />
                ))}
                {/*<Suspense fallback={null}>
                    <BitmapImage position={[-30,0,-25]} />
                </Suspense>*/}
            </Canvas>
        </div>
    );
};

export default Bubbles;